<h1 class="text-center">Agreement To Terms</h1>
<div style="max-height: calc(100vh-250px);" class="card">
    <div class="card-header">Terms &amp; Conditions</div>
    <div class="card-body">
      <h1>DUMMY</h1>>
    </div>
  </div>
  <r247-stepper-buttons nextCaption="Agree" (previousStep)="previousStep.emit()" (nextStep)="stepComplete.emit()"></r247-stepper-buttons>